import { Routes } from "@angular/router";
import { AuthGuardGuard } from "./auth-guard.guard";
import { LayoutWithNavbarComponent } from "./components/layout-with-navbar/layout-with-navbar.component";
import { LoginComponent } from "./login/login.component";
import { RoomsComponent } from "live-lesson/moderator/feature-shell";
import { LessonHasNotEndedGuard } from "live-lesson/shared/auth";
import { CallEndedPageComponent, CallExpiredOrInvalidPageComponent } from "live-lesson/shared/feature-shell";

export const appRoutes: Routes = [
    {
        path: '',
        canActivate: [AuthGuardGuard],
        component: LayoutWithNavbarComponent, children: [
            {
                path: 'room',
                component: RoomsComponent,
                canActivate: [
                    AuthGuardGuard,
                    LessonHasNotEndedGuard,
                ],
                providers: [LessonHasNotEndedGuard]
            },
    ] },

    { path: 'expired', component: CallExpiredOrInvalidPageComponent },
    { path: 'call-ended', component: CallEndedPageComponent },

    { path: 'login', component: LoginComponent },
    { path: 'login/:liveLessonId', component: LoginComponent },
    { path: '**', pathMatch: 'full', redirectTo: '/login' },
];
